import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const VIN_ERROR_REPORTS_URL = `${API_URL}/devices`;

// Get VIN Error Reports
export const getVinErrorReports = createAsyncThunk(
  "vinErrorReports/getVinErrorReports",
  async (params: { page: number; limit: number; search?: string; startDate?: string; endDate?: string }) => {
    const response = await axios.get(`${VIN_ERROR_REPORTS_URL}/vin-error-reports`, { params });
    return response.data;
  }
);

